import React from 'react';
import { connect } from 'react-redux'

import Master from '../../Components/Master';
import Dialog from '../../Components/Dialog';
import { TextFieldHelper, CheckboxFieldWrapper } from '../../Components/Fields';
import { doPost } from '../../Redux/Actions'
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';

import { CirclePicker, SketchPicker } from 'react-color';

const ENDPOINT = "besondererDienst"

export const Fields = ({handleChange, handleChangeColor, zeiterfassung, zu_kuerzel, farbe, name, kuerzel, notiz, stunden, leitstand}) => (
    <Grid container spacing={8}>

        <TextFieldHelper n={6} value={name} onChange={handleChange('name')} label="Name" />
        <TextFieldHelper n={3} value={kuerzel} onChange={handleChange('kuerzel')} label="Kürzel" />
        <TextFieldHelper n={3} value={zu_kuerzel} onChange={handleChange('zu_kuerzel')} label="Zusammenfassen mit" helper="Anhand des Kürzels wird es in der Zeiterfassung zusammengefasst" />
                    
        <Grid item xs={12}><Divider /></Grid>
        <TextFieldHelper n={2} value={stunden} onChange={handleChange('stunden')} label="Stunden" type="number" />
        <TextFieldHelper n={4} multiline value={notiz} onChange={handleChange('notiz')} label="Notiz" />
        <CheckboxFieldWrapper n={2} checked={leitstand} onChange={handleChange('leitstand')} name="ist nicht Dienst relevant" />
        <CheckboxFieldWrapper n={2} checked={zeiterfassung} onChange={handleChange('zeiterfassung')} name="Zeiterfassung anzeigen" />

        <Grid item xs={12}><Divider /></Grid>
        <Grid item xs={6}>
            <CirclePicker color={farbe} onChangeComplete={handleChangeColor} />
        </Grid>
        <Grid item xs={6}>
            <SketchPicker color={farbe} onChangeComplete={handleChangeColor} />
        </Grid>

    </Grid>
)

class NewEntry extends Master {

	state = {
		newEntry: {}
	}

	render() {

		var {
			handleClickOpen, dialogOpen
		} = this.props

        var {
        	newEntry
        } = this.state

		return (
			<Dialog
                title="Neuer Dienst"
                saveAction={this.postData}
                closeAction={handleClickOpen}
                open={dialogOpen}
             >
				<Fields handleChange={this.handleChange} handleChangeColor={this.handleChangeColor} {...newEntry} />
			</Dialog>
		)
	}

}

const mapStateToProps = state => ({
    [ENDPOINT]: state[ENDPOINT],
})

const mapDispatchToProps = (dispatch, ownProps) => ({
    doPost: (data) => dispatch(doPost(ENDPOINT, "api/generic/" + ENDPOINT, data)),
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(NewEntry);


// WEBPACK FOOTER //
// ./src/Routes/BesondererDienst/NewEntry.js